import React from 'react';
import { useTranslation } from 'react-i18next';
import CommonTypography from '@src/new-components/Typography';
import {
  CAPTION_BLOCK_WIDTH_RANGE,
  CAPTION_REVEAL_MODE,
  CAPTION_MAX_LINES_RANGE,
  CAPTION_MAX_WORDS_RANGE,
} from '@vbee-holding/aivoice-shared-lib';
import ConfigRow from './controls/ConfigRow';
import SliderField from './controls/SliderField';
import NumberField from './controls/NumberField';
import RadioField from './controls/RadioField';

const CONTROL_WIDTH = 200;

const LayoutGroup = ({ layout, karaokeEnabled, onChange }) => {
  const { t } = useTranslation();
  const bySpeech = layout.revealMode === CAPTION_REVEAL_MODE.BY_SPEECH;

  const revealOptions = [
    {
      value: CAPTION_REVEAL_MODE.ALL_TEXT,
      label: t('captionRevealAllText'),
    },
    {
      value: CAPTION_REVEAL_MODE.BY_SPEECH,
      label: t('captionRevealBySpeech'),
      badge: t('captionBadgeBeta'),
    },
  ];

  return (
    <div className="config-group">
      <CommonTypography className="config-group-label" variant="body-14-medium">
        {t('captionLayout')}
      </CommonTypography>
      <div className="config-group-rows">
        <ConfigRow label={t('captionBlockWidth')}>
          <SliderField
            width={CONTROL_WIDTH}
            value={layout.blockWidth}
            range={CAPTION_BLOCK_WIDTH_RANGE}
            suffix="%"
            onChange={(blockWidth) => onChange({ blockWidth })}
          />
        </ConfigRow>

        {karaokeEnabled && (
          <>
            <RadioField
              name="caption-reveal-mode"
              options={revealOptions}
              value={layout.revealMode}
              onChange={(revealMode) => onChange({ revealMode })}
            />

            <ConfigRow label={t('captionMaxLines')} disabled={!bySpeech}>
              <NumberField
                width={CONTROL_WIDTH}
                value={layout.maxLines}
                range={CAPTION_MAX_LINES_RANGE}
                disabled={!bySpeech}
                onChange={(maxLines) => onChange({ maxLines })}
              />
            </ConfigRow>

            <ConfigRow label={t('captionMaxWords')} disabled={!bySpeech}>
              <NumberField
                width={CONTROL_WIDTH}
                value={layout.maxWords}
                range={CAPTION_MAX_WORDS_RANGE}
                disabled={!bySpeech}
                onChange={(maxWords) => onChange({ maxWords })}
              />
            </ConfigRow>
          </>
        )}
      </div>
    </div>
  );
};

export default LayoutGroup;
